import { Redirect } from 'react-router-dom';

import GuidelinesPage from '../components/pages/GuidelinesPage';
import NotFoundPage from '../components/pages/notfound/NotFoundPage';
import HowItWorksPage from '../components/pages/howitworks/HowItWorksPage';
import AccountPage from '../components/pages/account/AccountPage';
import ContactRequestPage from '../components/pages/contactrequest/ContactRequestPage';
import FaqPage from '../components/pages/faq/FaqPage';
import CashbackDirectoryPage from '../components/pages/directory/CashbackDirectoryPage';
import LegalNoticePage from '../components/pages/LegalNoticePage';
import MerchantCardPage from '../components/pages/merchantcard/MerchantCardPage';
import TermsPage from '../components/pages/terms/TermsPage';
import UnsubscribePage from '../components/pages/unsubscribe/UnsubscribePage';
import ValidationEbonPage from '../components/pages/ebon/ValidationEbonPage';
import ConfirmationEbonPage from '../components/pages/ebon/confirmation/ConfirmationEbonPage';
import ErrorEbonPage from '../components/pages/ebon/erreur/ErrorEbonPage';
import TermsOfSalesPage from '../components/pages/termsofsales/TermsOfSalesPage';
import MyEbonsPage from '../components/pages/ebon/reminder/MyEbonsPage';
import DownloadEbonBillPage from '../components/pages/ebon/download/DownloadEbonBillPage';
import ConfirmationKycPage from '../components/pages/ebon/kyc/ConfirmationKycPage';

import { accountRoutes } from './account';
import { PATH } from '../constants/path';
import { LOCALES } from '../constants/locale';

import { directoryRoutes } from './directory';
import { localizeRoutes } from '../utils/routeUtils';

/**
 * Routes to be prefixed with locale
 * Put all the primary routes (i.e all the routes that d'on depend on a parent route to be displaying)
 */
const localizableRoutes = [
    {
        path: PATH.HOME_PATH,
        exact: true,
        component: Redirect,
        to: PATH.CASHBACK_EBON_MOST_POPULAR_PATH
    },
    {
        path: PATH.HOW_IT_WORK_PATH,
        exact: true,
        component: HowItWorksPage
    },
    {
        path: `${PATH.MERCHANTPAGE_TYPE_PATH}:query`,
        component: MerchantCardPage
    },
    {
        path: PATH.CASHBACK_PATH,
        component: CashbackDirectoryPage
    },
    {
        path: PATH.ACCOUNT_PATH,
        component: AccountPage
    },
    {
        path: PATH.FAQ_PATH,
        exact: true,
        component: FaqPage
    },
    {
        path: PATH.LEGAL_NOTICE_PATH,
        exact: true,
        component: LegalNoticePage
    },
    {
        path: PATH.TERMS_PATH,
        exact: true,
        component: TermsPage
    },
    {
        path: PATH.TERMS_OF_SALES,
        exact: true,
        component: TermsOfSalesPage
    },
    {
        path: PATH.CONTACTREQUEST_PATH,
        exact: true,
        component: ContactRequestPage
    },
    {
        path: PATH.UNSUBSCRIBE_PATH,
        exact: true,
        component: UnsubscribePage
    },
    {
        path: `${PATH.EBON_VALIDATION_PATH}/:query`,
        exact: true,
        component: ValidationEbonPage
    },
    {
        path: `${PATH.EBON_CONFIRMATION_PATH}:orderId?`,
        exact: true,
        component: ConfirmationEbonPage
    },
    {
        path: `${PATH.EBON_ERROR_PATH}-:id`,
        component: ErrorEbonPage
    },
    {
        path: `${PATH.EBON_DOWNLOAD_BILL_PATH}`,
        component: DownloadEbonBillPage
    },
    {
        path: `${PATH.EBONS_REMINDER_PATH}`,
        component: MyEbonsPage
    },
    {
        path: PATH.KYC_CONFIRMATION_PATH,
        exact: true,
        component: ConfirmationKycPage
    }
];

export const routes = [
    ...localizableRoutes,
    ...localizeRoutes(LOCALES, localizableRoutes),
    {
        path: '/guidelines',
        exact: true,
        component: GuidelinesPage
    },
    {
        path: PATH.NOT_FOUND_PATH,
        exact: true,
        component: NotFoundPage
    },
    {
        component: NotFoundPage
    }
];

/**
 * First level routes + sub levels routes
 * Mainly used for breadcrumb
 */
const subRoutes = [...accountRoutes, ...directoryRoutes];

export const allRoutes = [...routes, ...subRoutes, ...localizeRoutes(LOCALES, subRoutes)];



// WEBPACK FOOTER //
// ./src/routes/index.js